import createIcon from '../../createIcon';

/**
 * @component @name PhonePaused
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgM0gxNVYxMEgxN1YzWk0yMCAxNS41QzE4Ljc1IDE1LjUgMTcuNTUgMTUuMyAxNi40MyAxNC45M0MxNi4wOCAxNC44MiAxNS42OSAxNC45IDE1LjQxIDE1LjE3TDEzLjIxIDE3LjM3QzEwLjM4IDE1LjkzIDguMDYgMTMuNjIgNi42MiAxMC43OEw4LjgyIDguNTdDOS4xIDguMzEgOS4xOCA3LjkyIDkuMDcgNy41N0M4LjcgNi40NSA4LjUgNS4yNSA4LjUgNEM4LjUgMy40NSA4LjA1IDMgNy41IDNINEMzLjQ1IDMgMyAzLjQ1IDMgNEMzIDEzLjM5IDEwLjYxIDIxIDIwIDIxQzIwLjU1IDIxIDIxIDIwLjU1IDIxIDIwVjE2LjVDMjEgMTUuOTUgMjAuNTUgMTUuNSAyMCAxNS41Wk0xOSAzVjEwSDIxVjNIMTlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PhonePaused = createIcon('PhonePaused', [
  [
    'path',
    {
      d: 'M17 3H15V10H17V3ZM20 15.5C18.75 15.5 17.55 15.3 16.43 14.93C16.08 14.82 15.69 14.9 15.41 15.17L13.21 17.37C10.38 15.93 8.06 13.62 6.62 10.78L8.82 8.57C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.5C21 15.95 20.55 15.5 20 15.5ZM19 3V10H21V3H19Z',
      key: 'rzg76b',
    },
  ],
]);

export default PhonePaused;
